<header class="header">
    <div class="container">
        <div class="header-wrapper flex-between">
            <div class="flex-align-center">
              <img src="/assets/upd-logo.png" class="logo-img" width="197" height="32" alt="SensoCor ML">
                <nav class="admin-nav">
                    <ul class="flex-align-center">
                        <li>
                            <a [routerLink]="['/admin', appRoutes.DOCTORS]" routerLinkActive="active">
                                {{'doctors.title' | translate}}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin', appRoutes.DEVICES]" routerLinkActive="active">
                                {{'devices.title' | translate}}
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="flex-align-center">
                <app-lang-select></app-lang-select>


                <app-profile-preview></app-profile-preview>
            </div>
        </div>
    </div>
</header>
